// src/components/admin/AdminDashboard.jsx
import React from "react";
import { useAuth } from "../../context/AuthContext";
import AdminLayout from "../layout/AdminLayout";
import DashboardOverview from "./DashboardOverview";

const AdminPanel = () => {
  const { user } = useAuth();

  if (user.role !== "ADMIN") {
    return (
      <div className="flex items-center justify-center min-h-screen text-xl text-red-600">
        Access Denied
      </div>
    );
  }

  return <DashboardOverview Layout={AdminLayout} canManage={false} basePath="/admin" />;
};

export default AdminPanel;
